<template>
  <page-layout
    v-loading="loading"
    :title="courseTitle"
    :icon-config="{
      isBack: true,
      isImg: false
    }"
  >
    <div class="center-panel">
      <div class="info">
        <h4>个人资料</h4>
        <div class="info-panel">
          <div class="info-panel-desc">
            <div class="portrait">
              <img v-if="false && userInfo.headimgurl" :src="userInfo.headimgurl" />
              <div v-else class="default-portrait">
                <i class="iconfont iconlogo"></i>
              </div>
            </div>
            <div class="info-panel-desc-item">
              <div class="name">
                <a>{{ userInfo.name }}</a>
              </div>
              <span class="word-normal">
                <i class="iconfont iconshouji"></i>
                <span>{{ userInfo.tel | phoneFilter }}</span>
              </span>
              <span class="word-normal" v-if="userInfo.org">
                <i class="iconfont iconjigou"></i>
                <span>{{ userInfo.org }}</span>
              </span>
              <span class="word-normal" v-if="userInfo.profession">
                <i class="iconfont iconzhiye"></i>
                <span>{{ userInfo.profession }}</span>
              </span>

              <div class="edit" @click="editUserInfoHandle">
                <el-button :style="{ width: '80px' }" type="primary">编辑</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="order-list">
        <h4 class="word-middle">订单列表</h4>
        <el-table :data="orderList">
          <el-table-column label="产品名称">
            <template slot-scope="scope">
              <span class="icon-big" :style="{ margin: '0 10px 4px 0' }"><img :src="vipSign"/></span>
              <span>{{ scope.row.product.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="课题数" width="120">
            <template slot-scope="{ row }">
              <span>{{ row | filterCourseNum }}</span>
            </template>
          </el-table-column>

          <el-table-column label="金额" width="100">
            <template slot-scope="{ row }">
              <span>{{ row.payFee || 0 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="订单编号" width="240">
            <template slot-scope="{ row }">
              <span>{{ row.outTradeNo || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单创建时间" width="160">
            <template slot-scope="{ row }">
              <span>{{ row.completeTime | dateFilter('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="课题到期时间" width="160">
            <template slot-scope="{ row }">
              <span>{{ getExpireTime(row) | dateFilter('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      :visible="editDialog"
      custom-class="normal-dialog full-dialog"
      title="修改个人资料"
      @close="editDialog = false"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="user-info">
        <el-form @submit.native.prevent label-position="top">
          <el-form-item>
            <span slot="label">姓名<span :style="{ color: '#F62733' }">*</span></span>
            <el-input placeholder="请填写姓名" v-model="formInfo.name"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">机构<span :style="{ color: '#F62733' }">*</span></span>
            <el-input placeholder="请填写机构名称（例如学校、研究所、企业）" v-model="formInfo.org"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">职业<span :style="{ color: '#F62733' }">*</span></span>
            <el-input placeholder="请输入职业" v-model="formInfo.profession"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="editInfoHandle" :style="{ width: '100%' }" type="primary">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </page-layout>
</template>

<script>
import vipBackground from '@/assets/img/会员条@2x.png';
import vipSign from '@/assets/img/权益-浅@2x.png';
import vipSign2 from '@/assets/img/权益-小.png';

import dayjs from 'dayjs';
import { services } from '@/service';
import { find } from 'lodash';

export default {
  data() {
    return {
      loading: false,
      vipBackground,
      vipSign,
      vipSign2,
      orderList: [],
      editDialog: false,
      formInfo: {
        name: '',
        org: '',
        profession: ''
      }
    };
  },

  filters: {
    formatDeadline(val) {
      return dayjs(val).format('YYYY-MM-DD');
    },
    filterCourseNum(row) {
      const charge = JSON.parse(row.product.productList[0].chargeStr || '{}');
      return charge.courseNum || 1;
    }
  },

  computed: {
    courseTitle() {
      return '个人中心';
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    getExpireTime(row) {
      const completeTime = row.completeTime || 0;
      const charge = JSON.parse(row.product.productList[0].chargeStr || '{}');
      const expirationTimeDelta = charge.expirationTimeDelta || 0;
      return completeTime + expirationTimeDelta;
    },
    editUserInfoHandle() {
      this.formInfo = {
        name: this.userInfo.name,
        org: this.userInfo.org,
        profession: this.userInfo.profession
      };
      this.editDialog = true;
    },
    async fetchData() {
      try {
        const { content } = await services.authriozation.getOrderList({
          productNames: ['实证分析'],
          size: 100,
          page: 0
        });
        this.orderList = content;
      } catch (err) {
        this.$error(err);
      }
    },
    goProductHandle() {
      // this.$router.push({
      //   path: '/product'
      // });
      const location = window.location;
      window.open(`${location.origin}${location.pathname}#/product`, '_blank');
    },
    getLimit(limits, condition) {
      if (limits && condition) {
        return find(limits, condition) || {};
      }
    },
    async editInfoHandle() {
      if (!this.formInfo.name) {
        this.$message({ type: 'warning', message: '请输入正确的姓名' });
        return;
      }

      if (!this.formInfo.org) {
        this.$message({ type: 'warning', message: '请填写机构名称（例如学校、研究所、企业）' });
        return;
      }

      if (!this.formInfo.profession) {
        this.$message({ type: 'warning', message: '请填写职业' });
        return;
      }

      try {
        await services.authriozation.setUserInfo({ ...this.userInfo, ...this.formInfo });
        this.editDialog = false;
        await this.$store.dispatch('getUserInfo');
        this.fetchData();
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$fontColor: #3d465a;
.center-panel {
  width: 1100px;
  margin: 0 auto;
  .info {
    margin: 20px 0;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e8ebef;
    h4 {
      padding: 20px 40px;
      color: #2c3443;
    }
    .info-panel {
      display: flex;
      justify-content: space-between;
      padding: 0 40px;
      margin-top: 20px;
      .info-panel-desc {
        display: flex;
        .portrait {
          width: 68px;
          height: 68px;
          overflow: hidden;
          border-radius: 68px;
          margin-right: 52px;
          img {
            display: block;
            width: 100%;
          }
          .default-portrait {
            text-align: center;
            .iconfont {
              font-size: 68px;
              color: #c6303a;
            }
          }
        }
        &-item {
          vertical-align: middle;
          .name {
            font-size: 20px;
            color: $fontColor;
            display: flex;
            align-items: center;
            a {
              display: inline-block;
            }
            .type {
              border-radius: 12px;
              line-height: 20px;
              border: 1px solid rgba(#a0acc0, 0.5);
              text-align: center;
              box-sizing: border-box;
              display: inline-block;
              margin-left: 12px;
              padding: 0 10px;

              .vip-icon {
                position: relative;
                top: 2px;
                height: 14px;
                margin-right: 4px;
              }

              .split-line {
                position: relative;
                padding-left: 5px;
                margin-left: 5px;

                &::before {
                  content: ' ';
                  position: absolute;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  height: 85%;
                  width: 1px;
                  background-color: rgba($fontColor, 0.8);
                }
              }

              & > span {
                color: rgba($fontColor, 0.8);
              }
            }
          }
          span {
            color: $fontColor;
          }
          .word-normal {
            margin: 20px 20px 0 0;
            display: inline-block;

            .iconfont {
              position: relative;
              top: 1px;
              margin-right: 2px;
            }
          }
          .icon-middle {
            margin-right: 5px;
          }
          .edit {
            margin: 20px 0 30px 0;
          }
        }
      }
      .vip-tip {
        position: relative;
        .front {
          position: absolute;
          cursor: pointer;
          top: 0;
          width: 100%;
          line-height: 50px;
          .icon-big {
            margin-left: 20px;
          }
          span {
            color: #fedda9;
            margin: 0 0 0 10px;
            line-height: 18px;
          }
          a {
            display: inline-block;
            width: 72px;
            line-height: 24px;
            background: #fedda9;
            border-radius: 12px;
            text-align: center;
            margin-left: 14px;
            color: $fontColor;
          }
        }
      }
    }
  }

  .order-list {
    h4 {
      margin: 15px 0 20px 0;
    }
    padding: 20px 40px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e8ebef;
    min-height: 560px;
  }
}

.user-info {
  padding: 20px 30px;
}
</style>
